import React from 'react';
import ErrorLog from '../utils/ErrorLog';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error to the server
        ErrorLog.error(error.message, { errorInfo, componentStack: errorInfo.componentStack });
    }

    render() {
        if (this.state.hasError) {
            return <h1>Something went wrong. Please Refresh Page.</h1>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
